import MBHeader from "./headerMb";
import WebHeader from "./headerWeb";

export default function Header() {
  return (
    <header>
      {/* 웹헤더 */}
      <WebHeader />
      {/* 모바일 헤더 */}
      <MBHeader text={""} />
    </header>
  );
}
